/* eslint-disable */
export default {
  noRecords: '最近の記録が見つかりません。',
  inBound: '着信',
  outBound: '発信',
  missed: '不在着信',
} as const;

// @key: @#@"noRecords"@#@ @source: @#@"No recent records found."@#@
// @key: @#@"inBound"@#@ @source: @#@"Inbound"@#@
// @key: @#@"outBound"@#@ @source: @#@"Outbound"@#@
// @key: @#@"missed"@#@ @source: @#@"Missed Call"@#@
